import formatNum from '@/filters/formatNum';

/**
 * Format money change like -$10,000.13%
 */
function formatMoney(value: number = 0, digits: number = 2): string {
    return value < 0
        ? '−$' + formatNum(Math.abs(value), digits)
        : '$' + formatNum(value, digits);
}

export default formatMoney;
